export default {
    state: {
        mobileNavActive: false
    },
    mutations: {
        toggleMobileNav() {
            this.state.mobileNavActive = !this.state.mobileNavActive
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store.js